import { Slide } from 'pure-react-carousel';
import React from 'react';
import s from './slideStyles';
import Slide8 from './slide_8.svg';

export default ({ index }) => (
    <Slide className={s.slideWrapper} index={index}>
        <div className={s.imageWrapper}>
            <Slide8 />
        </div>
        <div className={s.textWrapper}>
            <p>
                Hvis computeren ikke kan komme frem til et svar, på basis af den
                viden den har, vil platformen pege på de steder der mangler data
                eller viden, for at komme frem til det korrekte svar.
            </p>
            <p>
                <em>Here illustrated as building blocks.</em>
            </p>
        </div>
    </Slide>
);



// WEBPACK FOOTER //
// ./src/components/sections/ourVirtualExperts/steps/slides/slide8.component.js